import { CIMSTabs } from 'components/CIMSTabs'
import Queue from './components/Queue'
import Request from './components/Request'

const PhotoExports: React.FC = () => {
  const Tab = { queue: 'Queue', request: 'Photo Request' } as const
  return (
    <CIMSTabs
      tabs={[
        { label: Tab.queue, key: Tab.queue, component: <Queue /> },
        { label: Tab.request, key: Tab.request, component: <Request /> },
      ]}
      initialTab={Tab.queue}
    />
  )
}

export default PhotoExports
